import { Typography } from "@mui/material";

export const dialogContent = (
  <>
    <Typography>
      <strong>Are you sure you want to submit this playlist?</strong>
    </Typography>
    <br />
    <Typography>
      There are <strong>selected</strong> activities that{" "}
      <strong>have not been added</strong>.
    </Typography>
    <br />
    <Typography sx={{ fontStyle: "italic" }}>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/no-unescaped-entities */}
      Hint: make sure to click "Add to Playlist" after you have selected the
      proper activities. Check if an activity has been added by viewing the
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/no-unescaped-entities */}
      "Playlist To Be Submitted" beneath the activities table prior to
      submitting.
    </Typography>
  </>
);
